import { Card } from "@velocity-ehs/component-library";
import FormSkeleton from "../../sharedComponents/FormSkeleton";
import { UserForm } from "./UserForm";
import { useTranslation } from "react-i18next";
import { PersonUserForm } from "./Person";
import { useEffect } from "react";

type UserDetailsProps = {
  personUser?: PersonUserForm;
  personId?: string;
  personEmail?: string;
  readOnly: boolean;
  refetch: () => void;
  isLoading?: boolean;
};

const UserDetails = ({
  personUser,
  personId,
  personEmail,
  readOnly,
  refetch,
  isLoading,
}: UserDetailsProps) => {
  const { t } = useTranslation();

  useEffect(() => {
    refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Card title={t("person_user_details")}>
      {isLoading ? (
        <FormSkeleton rows={3} />
      ) : (
        <UserForm
          user={personUser}
          personId={personId}
          personEmail={personEmail}
          readOnly={readOnly}
          refetch={refetch}
        />
      )}
    </Card>
  );
};

export { UserDetails };
